export default "__VITE_ASSET__9d735a1b__"